export default "__VITE_ASSET__CAsJaS1G__"